import React, { memo } from 'react'
import { faStore } from '@fortawesome/pro-duotone-svg-icons'

import FilterMenu from '../shared/filterMenu/FilterMenu'
import { SHOP_URL_FILTER_TYPE } from '../../util/shop.helpers'

import RedeemContainer from '../../containers/RedeemContainer'
import NftsContainer from '../../containers/NftsContainer'
import PageTitle from '../shared/pageTitle/PageTitle'
import customConfig from 'customConfig'

const Shop = ({ isNftEnabled, t, onChangeFilterMenu, filterBy }) => {
  const pageTitle = t('navigation.qiibee-shop')
  const renderTabData = () => {
    switch (filterBy) {
      case SHOP_URL_FILTER_TYPE.SHOP:
        return <RedeemContainer />

      case SHOP_URL_FILTER_TYPE.MY_ITEMS:
        return <NftsContainer />

      default:
        return null
    }
  }
  return (
    <>
      <PageTitle title={pageTitle} />
      <FilterMenu
        value={filterBy}
        options={buildShopFilterOptions({ isNftEnabled, t })}
        onChange={onChangeFilterMenu}
      />
      {renderTabData()}
    </>
  )
}

export default memo(Shop)

const buildShopFilterOptions = ({ isNftEnabled, t }) => {
  return [
    {
      value: SHOP_URL_FILTER_TYPE.SHOP,
      label: t('shop.shop'),
      icon: faStore
    },
    ...(isNftEnabled
      ? [
          {
            value: SHOP_URL_FILTER_TYPE.MY_ITEMS,
            label: t('shop.my-items'),
            icon: customConfig.nftIcon
          }
        ]
      : [])
  ]
}
